<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { request } from '../services/api'
import FantanBetPage from './FantanBetPage.vue'
import PjxBetPage from './PjxBetPage.vue'
import PaijiuBetPage from './PaijiuBetPage.vue'
import SaicheBetPage from './SaicheBetPage.vue'
import LiuheBetPage from './LiuheBetPage.vue'

const route = useRoute()
const game = ref(null)
const loading = ref(true)
const errorMessage = ref('')

// 各彩种使用独立页面；liuhe 从后端读取恢复后的玩法和历史。
const templates = {
  liuhe: LiuheBetPage,
  saiche: SaicheBetPage,
  fantan: FantanBetPage,
  paijiu: PaijiuBetPage,
  pjx: PjxBetPage,
}
const templateName = computed(() => String(game.value?.game_template || '').toLowerCase())
const betComponent = computed(() => templates[templateName.value] || null)

onMounted(async () => {
  try {
    const response = await request('/game/lists')
    game.value = (response.data?.lists || []).find((item) => String(item.game_id) === String(route.params.game)) || null
    if (!game.value) errorMessage.value = '未找到该游戏，或您没有该游戏的权限。'
  } catch (error) {
    errorMessage.value = error.message || '游戏信息加载失败。'
  } finally {
    loading.value = false
  }
})
</script>

<template>
  <p v-if="loading" class="dispatch-state">加载中…</p>
  <component v-else-if="betComponent" :is="betComponent" />
  <section v-else class="dispatch-state">
    <p>{{ errorMessage || `暂不支持的游戏模板：${templateName || '（未配置）'}` }}</p>
    <!-- 旧版没有「游戏大厅」这个页面，返回一律回彩票大厅 -->
    <RouterLink to="/home">返回彩票大厅</RouterLink>
  </section>
</template>

<style scoped>
.dispatch-state{margin:40px 20px;color:#888;text-align:center;font-size:13px}
.dispatch-state a{display:inline-block;margin-top:14px;color:#f04141;text-decoration:none}
</style>
